import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson5 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
        $x = 10; //global variable

        function foo() {
        $y = 20;  //local variable
        static $z = 3-; //static variable

        echo $x;  //Outputs 10;
        echo $y; //Outputs 20
        echo $z;  //Outputs 30
        }

        foo();
        ?>

        `
      );
      const code1 = (
        'text',
        `
        <?php
        $x 10;
        $y = 20;

        function sum() {
            global $x, $y;
            return $x + $y;

        }

        echo sum();  //Outputs 30
        ?>

        `
      );

      const code2 = (
        'text',
        `
        <?php
        function myFunction(){
            //Declare a local variable called $x;
        $x = 5;
        echo $x;
        }

        myFunction();
        echo $x;  //Produces an error
        ?>

        `
      );





  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">

    <h3><strong>Variable Scope</strong></h3>

    <p>In PHP, variables have a "scope" which determines where in a script a variable is available for use. There are three main scopes in PHP:</p>
    <ol class="list-group list-group-numbered mb-4">
    <li class="list-group-item"><b>Local scope</b>: A local variable is only available within the function where it is defined. It is created when the function is called, and it is destroyed when the function is finished.</li>
    <li class="list-group-item"><b>Global scope</b>: A global variable is available for use anywhere in a PHP script. It is created when it is first defined, and it is destroyed when the script finishes running.</li>
    <li class="list-group-item"><b>Static scope</b>: A static variable retains its value between function calls, so it is not destroyed when the function finishes. This can be useful for keeping track of data that needs to be accessed across multiple function calls.</li>
    </ol>

    <p>Here is an example to illustrate these scopes:</p>
    <CopyBlock
    language={"php"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>The first time <b>foo()</b> is called, the local variable <b>$y</b> is created and the static variable <b>$z</b> is created and initialized with the value 30. The second time <b>foo()</b> is called,
    <b>$y</b> is re-created and its value is reset to 20, but <b>$z</b> retains its value from the previous function call (it does not get re-initialized to 30).</p>
    </div>

    <div className="alert alert-secondary" role="alert">
    <h3><strong>Global Scope</strong></h3>
   <p>In PHP, a global variable is a variable that is defined outside of a function and is available for use inside of functions and other scopes.</p>
   <p>To access a global variable inside a function, you can use the global keyword followed by the variable name. For example:</p>
   <CopyBlock
    language={"php"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>It's important to note that global variables should be used with caution, as they can make your code more difficult to maintain and debug.</p>
    <p>A better approach is often to use function arguments and return values to pass data between functions.</p>
    <p>PHP also has a concept of <b>superglobals</b>, which are special variables that are available in all scopes throughout a PHP script.
    These variables include <b>$_SERVER</b>, <b>$_POST</b>, <b>$_GET</b>, <b>$_FILES</b>, <b>$_COOKIE</b>, <b>$_SESSION</b>, <b>$_REQUEST</b>, <b>$_ENV</b>, and more. </p>
    </div>
    <div className="alert alert-secondary" role="alert">
    <h3><strong>Local Scope</strong></h3>
    <p>In PHP, a local variable is a variable that is declared within a function or a block of code. Local variables are only accessible within the function or block of code in which they are declared.</p>
    <p>They are created when the function or block of code is entered, and they are destroyed when the function or block of code is exited.</p>

    <p>Here is an example of how to declare and use a local variable in PHP:</p>
    <CopyBlock
    language={"php"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>In this example, the local variable <b>`$x`</b> is declared within the <b>myFunction</b> function. It can be used within the function, but it is not accessible outside of the function. If you try to access <b>`$x`</b> outside of the function, you will get an error.</p>

    </div>
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson5
